// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styles */

body {
    margin: 0;
    padding: 0;
    font-family: "Poppins", Arial, sans-serif;
    background-color: #f8f9fa;
    color: #333;
  }
  
  .container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
  
  /* Header */
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 40px;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    position: sticky;
    top: 0;
    z-index: 1000;
  }
  
  /* Flex Container for Logo, Links, and Buttons */
  .header {
    display: flex;
    align-items: center;
  }
  
  /* Logo - Top Left */
  .logo-container {
    cursor: pointer;
    flex: 1 1;
  }
  
  .logo {
    height: 50px;
  }
  
  /* Navigation Links - Center */
  .nav-links {
    font-size:20px;
    display: flex;
    gap: 40px;
    justify-content: center;
    flex: 2 1;
  }
  
  .nav-links span {
    cursor: pointer;
    font-weight: 500;
    color: #09609e;
    transition: color 0.3s ease;
  }
  
  .nav-links span:hover {
    color: #0056b3;
  }
  
  /* Auth Buttons - Top Right */
  .auth-buttons {
    display: flex;
    gap: 15px;
    flex: 1 1;
    justify-content: flex-end;
  }
  
  .nav-button {
    padding: 8px 16px;
    font-size: 1.1rem;
    font-weight: bold;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    width: 8rem;
  }
  
  .nav-button.login {
    background-color: #053783;
    padding: 15px;
    border-radius: 50px;
  }

  .nav-button.signup {
    padding: 15px;
    border-radius:50px;
    color: #053783;
    background-color: #ffffff;
    border-style:solid;
    border-color: #053783;
  }

  .nav-button.login:hover {
    background-color: #3d95d4;
  }
  
  .nav-button.signup:hover {
    color:#3d95d4;
    border-style:solid;
    border-color: #3d95d4;
  }
  
  /* Center Content */
  .center-content {
    flex: 1 1;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }
  
  .giant-logo {
    height: 200px;
    max-width: 90%;
    object-fit: contain;
  }
  
  /* Footer */
  .footer-links {
    text-align: center;
    padding: 10px 0;
    background-color: #f1f1f1;
    font-size: 0.9rem;
    color: #555;
  }
  
  .footer-links span {
    cursor: pointer;
    color: #007bff;
    transition: color 0.3s;
  }
  
  .footer-links span:hover {
    color: #0056b3;
  }
  
  .separator {
    margin: 0 10px;
    color: #777;
  }
  
  .footer-links p {
    margin: 5px 0;
    color: #777;
  }
  
  /* General Container */
.center-content {
    margin-right:7rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    padding: 20px;
  }
  
  /* Device Wrapper */
  .device-container {
    position: relative; 
    display: inline-block;
  }
  
  /* Laptop & Phone Images */
  .laptop-image {
    width: 40rem;
    height: auto;
    object-fit: contain;

  }
  
  .phone-image {
    width: 10rem;
    object-fit: contain;
    border-radius: 10px;
  
  }
  
  /* Logo Overlay (Shared Styles) */
  .logo-overlay {
    position: absolute;
    object-fit: contain;
    pointer-events: none; 
    opacity: 0.9;         
  }
  
  /* Position of Logo Inside Laptop */
  .laptop-logo {
    top:8.5%; 
    left: 21%; 
    width: 57%; 
  }
  
  /* Position of Logo Inside Phone */
  .phone-logo {
    top: 20%;  
    left: 15%; 
    width: 70%; 
  }
  
  /* Headline Text */
.headline {
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
    color: #053783;
    max-width: 600px;
    margin: 20px auto;
    line-height: 1.5;
    padding: 0 15px;
  }

  /* Highlighted Text Style */
.highlight {
    color: #007bff;  
    font-weight: 700;  
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/LandingPage.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAGnB;IACI,SAAS;IACT,UAAU;IACV,yCAAyC;IACzC,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA,WAAW;EACX;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,wCAAwC;IACxC,gBAAgB;IAChB,MAAM;IACN,aAAa;EACf;;EAEA,gDAAgD;EAChD;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA,oBAAoB;EACpB;IACE,eAAe;IACf,SAAO;EACT;;EAEA;IACE,YAAY;EACd;;EAEA,8BAA8B;EAC9B;IACE,cAAc;IACd,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,SAAO;EACT;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,2BAA2B;EAC7B;;EAEA;IACE,cAAc;EAChB;;EAEA,6BAA6B;EAC7B;IACE,aAAa;IACb,SAAS;IACT,SAAO;IACP,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA,mBAAmB;EACnB;IACE,SAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,cAAc;IACd,mBAAmB;EACrB;;EAEA,WAAW;EACX;IACE,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA,sBAAsB;AACxB;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;;EAEA,mBAAmB;EACnB;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA,0BAA0B;EAC1B;IACE,YAAY;IACZ,YAAY;IACZ,mBAAmB;;EAErB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;;EAErB;;EAEA,iCAAiC;EACjC;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;EACd;;EAEA,mCAAmC;EACnC;IACE,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;;EAEA,kCAAkC;EAClC;IACE,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;;EAEA,kBAAkB;AACpB;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;;EAEA,2BAA2B;AAC7B;IACI,cAAc;IACd,gBAAgB;EAClB","sourcesContent":["/* General Styles */\n@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n\nbody {\n    margin: 0;\n    padding: 0;\n    font-family: \"Poppins\", Arial, sans-serif;\n    background-color: #f8f9fa;\n    color: #333;\n  }\n  \n  .container {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n  }\n  \n  /* Header */\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px 40px;\n    background-color: #fff;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    position: sticky;\n    top: 0;\n    z-index: 1000;\n  }\n  \n  /* Flex Container for Logo, Links, and Buttons */\n  .header {\n    display: flex;\n    align-items: center;\n  }\n  \n  /* Logo - Top Left */\n  .logo-container {\n    cursor: pointer;\n    flex: 1;\n  }\n  \n  .logo {\n    height: 50px;\n  }\n  \n  /* Navigation Links - Center */\n  .nav-links {\n    font-size:20px;\n    display: flex;\n    gap: 40px;\n    justify-content: center;\n    flex: 2;\n  }\n  \n  .nav-links span {\n    cursor: pointer;\n    font-weight: 500;\n    color: #09609e;\n    transition: color 0.3s ease;\n  }\n  \n  .nav-links span:hover {\n    color: #0056b3;\n  }\n  \n  /* Auth Buttons - Top Right */\n  .auth-buttons {\n    display: flex;\n    gap: 15px;\n    flex: 1;\n    justify-content: flex-end;\n  }\n  \n  .nav-button {\n    padding: 8px 16px;\n    font-size: 1.1rem;\n    font-weight: bold;\n    color: #fff;\n    background-color: #007bff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    width: 8rem;\n  }\n  \n  .nav-button.login {\n    background-color: #053783;\n    padding: 15px;\n    border-radius: 50px;\n  }\n\n  .nav-button.signup {\n    padding: 15px;\n    border-radius:50px;\n    color: #053783;\n    background-color: #ffffff;\n    border-style:solid;\n    border-color: #053783;\n  }\n\n  .nav-button.login:hover {\n    background-color: #3d95d4;\n  }\n  \n  .nav-button.signup:hover {\n    color:#3d95d4;\n    border-style:solid;\n    border-color: #3d95d4;\n  }\n  \n  /* Center Content */\n  .center-content {\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n  }\n  \n  .giant-logo {\n    height: 200px;\n    max-width: 90%;\n    object-fit: contain;\n  }\n  \n  /* Footer */\n  .footer-links {\n    text-align: center;\n    padding: 10px 0;\n    background-color: #f1f1f1;\n    font-size: 0.9rem;\n    color: #555;\n  }\n  \n  .footer-links span {\n    cursor: pointer;\n    color: #007bff;\n    transition: color 0.3s;\n  }\n  \n  .footer-links span:hover {\n    color: #0056b3;\n  }\n  \n  .separator {\n    margin: 0 10px;\n    color: #777;\n  }\n  \n  .footer-links p {\n    margin: 5px 0;\n    color: #777;\n  }\n  \n  /* General Container */\n.center-content {\n    margin-right:7rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 2rem;\n    padding: 20px;\n  }\n  \n  /* Device Wrapper */\n  .device-container {\n    position: relative; \n    display: inline-block;\n  }\n  \n  /* Laptop & Phone Images */\n  .laptop-image {\n    width: 40rem;\n    height: auto;\n    object-fit: contain;\n\n  }\n  \n  .phone-image {\n    width: 10rem;\n    object-fit: contain;\n    border-radius: 10px;\n  \n  }\n  \n  /* Logo Overlay (Shared Styles) */\n  .logo-overlay {\n    position: absolute;\n    object-fit: contain;\n    pointer-events: none; \n    opacity: 0.9;         \n  }\n  \n  /* Position of Logo Inside Laptop */\n  .laptop-logo {\n    top:8.5%; \n    left: 21%; \n    width: 57%; \n  }\n  \n  /* Position of Logo Inside Phone */\n  .phone-logo {\n    top: 20%;  \n    left: 15%; \n    width: 70%; \n  }\n  \n  /* Headline Text */\n.headline {\n    text-align: center;\n    font-size: 2rem;\n    font-weight: bold;\n    color: #053783;\n    max-width: 600px;\n    margin: 20px auto;\n    line-height: 1.5;\n    padding: 0 15px;\n  }\n\n  /* Highlighted Text Style */\n.highlight {\n    color: #007bff;  \n    font-weight: 700;  \n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
